import Vue from 'vue'
import Router from 'vue-router'
import goodsHome from './views/goods/goodsHome/goodsHome'
import teamHome from './views/team/teamHome/teamHome'
import recruitHome from './views/recruit/recruitHome/recruitHome'
import fail from './views/recruit/fail/fail'
import bill from './views/recruit/bill/bill'
import call from './views/recruit/call/call'
import log from './views/recruit/log/log'
import orderHome from './views/order/orderHome/orderHome'
import profitHome from './views/profit/profitHome/profitHome'
import guize from './views/profit/guize/guize'
import taskList from './views/activity/taskList/taskList'
import taskInfo from './views/activity/taskInfo/taskInfo'
import orderList from './views/activity/orderList/orderList'
import goodsDetail from './views/goods/goodsDetail/goodsDetail'
import yaopin from './views/goods/goodsDetail/yaopin'
import detail from './views/goods/activityGoods/detail'
import defaultDetail from './views/goods/activityGoods/default'
import pkList from './views/activity/pkList/pkList'


Vue.use(Router);

export default new Router({
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    },
    base: 'distribution',
    mode: 'history',
    routes: [
        {
            path: '/goodsHome',
            name: 'goodsHome',
            component: goodsHome,
            meta: {
                title: '药联健康大使',
                requireAuth: true,
                page_type: ''
            }
        }, {
            path: '/teamHome',
            name: 'teamHome',
            component: teamHome,
            meta: {
                title: '我的团队',
                requireAuth: true,
                page_type: ''
            }
        },
        {
            path: '/recruitHome',
            name: 'recruitHome',
            component: recruitHome,
            meta: {
                title: '',
                requireAuth: true,
                page_type: ''
            }
        },{
            path: '/fail',
            name: 'fail',
            component: fail,
            meta: {
                title: '',
                requireAuth: true,
                page_type: ''
            }
        },{
            path: '/bill',
            name: 'bill',
            component: bill,
            meta: {
                title: '我的海报',
                requireAuth: false,
                page_type: ''
            }
        },{
            path: '/orderHome',
            name: 'orderHome',
            component: orderHome,
            meta: {
                title: '我的订单',
                requireAuth: true,
                page_type: ''
            }
        }, {
            path: '/shortHome', // 旧 profitHome
            name: 'profitHome',
            component: profitHome,
            meta: {
                title: '收益中心',
                requireAuth: true,
                page_type: ''
            }
        }, {
            path: '/guize',
            name: 'guize',
            component: guize,
            meta: {
                title: '晋升规则',
                requireAuth: false,
                page_type: ''
            }
        }, {
            path: '/call',
            name: 'call',
            component: call,
            meta: {
                title: '联系助手',
                requireAuth: true,
                page_type: ''
            }
        }, {
            path: '/taskList',
            name: 'taskList',
            component: taskList,
            meta: {
                title: '积分任务',
                requireAuth: true,
                page_type: '',
                keepAlive: true,
            }
        }, {
            path: '/taskInfo',
            name: 'taskInfo',
            component: taskInfo,
            meta: {
                title: '积分任务',
                requireAuth: true,
            }
        },{
            path:'/orderList',
            name:'orderList',
            component:orderList,
            meta: {
                title: '关联订单',
                requireAuth: true,
                page_type: ''
            }
        },{
            path:'/goodsDetail',
            name:'goodsDetail',
            component:goodsDetail,
            meta: {
                title: '预览服务包详情',
                requireAuth: false,
            }
        },{
            path:'/yaopin',
            name:'yaopin',
            component:yaopin,
            meta: {
                title: '适用药品',
                requireAuth: false,
            }
        },{
            path:'/pkList',
            name:'pkList',
            component:pkList,
            meta: {
                title: '销售业绩排名',
                requireAuth: true,
            }
        },{
            path:'/detail',
            name:'detail',
            component:detail,
            meta: {
                title: '服务详情',
                requireAuth: true,
                keepAlive: false,
            }
        },{
            path:'/default',
            name:'defaultDetail',
            component:defaultDetail,
            meta: {
                title: '商品详情',
                requireAuth: true,
            }
        },{
            path:'/log',
            name:'log',
            component:log,
            meta: {
                title: '砍价记录',
                requireAuth: false,
                // keepAlive: false,
            }
        }
    ]
})
